<template>
  <div ref="container" class="turnstile-widget"></div>
</template>

<script>
import { loadTurnstileScript } from "@/utils/turnstile";

export default {
  name: "TurnstileWidget",
  props: {
    siteKey: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      default: "light",
    },
  },
  data() {
    return {
      widgetId: null,
    };
  },
  mounted() {
    this.renderWidget();
  },
  beforeDestroy() {
    this.removeWidget();
  },
  methods: {
    async renderWidget() {
      if (!this.siteKey) {
        this.$emit("error", new Error("Turnstile site key is not configured"));
        return;
      }

      try {
        await loadTurnstileScript();
        if (!this.$refs.container || !window.turnstile) {
          return;
        }

        this.widgetId = window.turnstile.render(this.$refs.container, {
          sitekey: this.siteKey,
          theme: this.theme,
          callback: (token) => {
            this.$emit("verify", token);
          },
          "error-callback": () => {
            this.$emit("error");
          },
          "expired-callback": () => {
            this.$emit("expire");
          },
        });
      } catch (error) {
        this.$emit("error", error);
      }
    },
    reset() {
      if (window.turnstile && this.widgetId != null) {
        window.turnstile.reset(this.widgetId);
      }
    },
    removeWidget() {
      if (window.turnstile && this.widgetId != null) {
        window.turnstile.remove(this.widgetId);
        this.widgetId = null;
      }
    },
  },
};
</script>
